import { render, staticRenderFns } from "./UserVip.vue?vue&type=template&id=11ca8b5c&scoped=true&"
import script from "./UserVip.vue?vue&type=script&lang=js&"
export * from "./UserVip.vue?vue&type=script&lang=js&"
import style0 from "./UserVip.vue?vue&type=style&index=0&id=11ca8b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca8b5c",
  null
  
)

export default component.exports